module.exports = __webpack_public_path__ + "icon.png?612bd058748fd35ef1a2bc8847a66c34";


//////////////////
// WEBPACK FOOTER
// ./static/assets/icon.png
// module id = 530
// module chunks = 0